import { ArrowRight } from 'lucide-react';

export function Hero() {
  return (
    <section id="accueil" className="relative bg-[#F0F8FF] py-10 px-4 sm:py-16 sm:px-6 md:py-20 overflow-hidden">
      {/* Background decorative elements */}
      <div className="hidden lg:block absolute top-20 left-10 w-8 h-8 bg-yellow-400 rotate-45" />
      <div className="hidden lg:block absolute top-40 right-20 w-12 h-12 bg-violet-600 rounded-full" />
      <div
        className="hidden lg:block absolute bottom-20 left-1/4 w-6 h-6 bg-cyan-400"
        style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }}
      />

      <div className="max-w-7xl mx-auto relative">
        <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div>
            <h1 className="text-[26px] min-[400px]:text-[30px] sm:text-5xl md:text-4xl lg:text-5xl xl:text-7xl font-black leading-tight sm:leading-tight md:leading-tight xl:leading-none mb-4 sm:mb-6">
              DÉVELOPPEUR WEB FREELANCE FULL-STACK
            </h1>
            <p className="text-base sm:text-xl md:text-2xl mb-6 sm:mb-8 leading-relaxed font-bold">
              Je crée votre identité numérique complète : sites web sur mesure et designs percutants (logos, cartes, flyers).
            </p>
            <a
              href="#contact"
              className="inline-flex bg-cyan-400 text-black px-5 py-3 sm:px-8 sm:py-4 font-black text-base sm:text-xl border-4 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] sm:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] sm:hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1.5 hover:translate-y-1.5 transition-all items-center gap-3 group"
            >
              CONTACTEZ-MOI !
              <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-2 transition-transform" />
            </a>
          </div>

          <div className="relative mx-2 sm:mx-6 md:mx-0">
            <div className="relative rotate-3 transform">
              <div className="bg-yellow-300 border-4 border-black p-5 sm:p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] sm:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] md:shadow-[16px_16px_0px_0px_rgba(0,0,0,1)]">
                <div className="text-center">
                  <div className="w-20 h-20 sm:w-32 sm:h-32 mx-auto mb-3 sm:mb-4 bg-violet-600 border-4 border-black rounded-full flex items-center justify-center">
                    <span className="text-white text-3xl sm:text-5xl font-black">LL</span>
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-black mb-1 sm:mb-2">LÉO LANGLOIS</h2>
                  <p className="text-base sm:text-lg font-bold">Développeur Web Full-Stack</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Polka dots pattern */}
      <div className="hidden md:grid absolute bottom-10 right-10 grid-cols-4 gap-3">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="w-4 h-4 bg-orange-600 rounded-full" />
        ))}
      </div>
    </section>
  );
}
